import {
  ThemeProvider as StyledComponentsThemeProvider,
  createGlobalStyle
} from "styled-components"
import { normalize } from "polished"
import theme from "./theme"

const GlobalStyle = createGlobalStyle`
  ${normalize()}

  body {
    color: ${theme.palette.defaultFG};
    background-color: ${theme.palette.defaultBG};
    flex-direction: column;
    font-Size: 16px;
    font-family: "NotoSans-Regular";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  #root {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  * {
    box-sizing: border-box;
  }

  a {
    text-decoration: none;    
    &:visited, &:active, &:link {
      color: inherit;
    }
  }
`

export default function ApplicationThemeProvider({ children }) {
  return (
    <StyledComponentsThemeProvider theme={theme}>
      <GlobalStyle />
      {children}
    </StyledComponentsThemeProvider>
  )
}
